export default __webpack_public_path__ + "static/media/ic_dashboard.e50f5a91.svg";